import 'url-search-params-polyfill'

/*
 * flag - flag name prefixed with 'cti' (ex.cti.feature-flag) to match url query Param
 */
export function featureFlag(flag) {
  if (flag && window.location.search) {
    const urlParams = new URLSearchParams(window.location.search)
    const queryResult = urlParams.get('featureflag')

    return flag === queryResult
  }
}
